import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useCustomBackButtonHandler = (callback) => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleBackButton = (e) => {
            e.preventDefault();
            e.returnValue = false;
            e.stopImmediatePropagation();
            callback(); // Invoke the provided callback function
        };

        window.onpopstate = handleBackButton;

        return () => {
            window.onpopstate = null; // Clean up the event listener
        };
    }, [callback, navigate]);
};

export default useCustomBackButtonHandler;
